
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/global",
      function () {
        return require("private-next-pages/global.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/global"])
      });
    }
  